var _defs, _rect, _rect2, _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiyarams01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1301 348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f9d7;}.cls-2{fill:#231f20;}.cls-3{fill:red;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.24,
    y: -0.33,
    width: 1293,
    height: 348.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 153.39,
    y: 37.84,
    width: 1002.7,
    height: 281.53
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "385.57 93.27 349.11 93.27 344.19 118.85 380.65 118.85 385.57 93.27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.91,126.24c16.91-3.73,37,5.33,37,5.33l9-26.61c-33.81-10.11-56-4.77-56-4.77-47.56,8.51-50.73,31.91-50.2,52.13s32.77,31.38,46.51,36.7S265,209.24,265,209.24c-18,24.48-65,2.65-65,2.65l-8.47,26.6c57.61,17,104.14,5.86,111.53-33s-39.64-47.87-39.64-47.87C238.09,146.47,255,130,271.91,126.24Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "339.59 137.95 317.39 242.22 353.85 242.22 376.06 137.95 339.59 137.95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1053,127.51l-10,14.06h6.48l36.91-49.19H1035l-5,21.08a154,154,0,0,0,18.45,1C1059.47,114.46,1053,127.51,1053,127.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M802.65,143.07c-30.41-20.08-72.29,0-72.29,0l-1,23.09c36.4-17.56,51.86-2,53.86,5s-7,6.52-7,6.52c-8.48-.51-22.44-1-22.44-1-26.93-.49-50.86,15.55-51.86,34.63s5.49,27.59,29.42,33.12,37.9-10.54,40.89-13.55,3,3.5,3,3.5l-.51,8.54h26.93c0-6,10.47-45.67,10.47-45.67C826.59,159.13,802.65,143.07,802.65,143.07Zm-44.37,78.29a8,8,0,0,1-.73.34c-11.2,4.87-32.37-2.17-18.72-16.9,14-15.06,38.89-9,38.89-9C777.72,207.81,769.25,215.84,758.28,221.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1080.54,136c-38.72,6.42-41.3,24.09-40.87,39.35s26.67,23.7,37.86,27.71,5.59,15.26,5.59,15.26c-14.64,18.48-52.91,2-52.91,2l-6.89,20.07c46.89,12.85,84.77,4.42,90.79-24.9s-32.27-36.14-32.27-36.14c-20.65-8.43-6.89-20.89,6.87-23.7s30.13,4,30.13,4l7.33-20.09C1098.65,131.94,1080.54,136,1080.54,136Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M595.72,143.07c-30.4-20.08-72.29,0-72.29,0l-1,23.09c36.39-17.56,51.87-2,53.85,5s-7,6.52-7,6.52c-8.47-.51-22.44-1-22.44-1-26.93-.49-50.86,15.55-51.85,34.63s5.48,27.59,29.41,33.12,37.9-10.54,40.89-13.55,3,3.5,3,3.5l-.5,8.54h26.92c0-6,10.48-45.67,10.48-45.67C619.66,159.13,595.72,143.07,595.72,143.07Zm-44.38,78.29a5.3,5.3,0,0,1-.72.34c-11.19,4.87-32.37-2.17-18.72-16.9,14-15.06,38.89-9,38.89-9C570.8,207.81,562.32,215.84,551.34,221.36Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M714.79,138.05s-18.84-6-29.31,2.51A96.77,96.77,0,0,0,668,159.63l2.89-21.58H639.36L617.67,242h33.91l11-47.19s10-41.65,45.87-27.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M470.57,138.05l-35.9,66.24s-4.49-4-4.49-8.54l-8.59-57.7H385.68l25.06,104.89s-9.49,30.11-39.4,16.56l-7,25.09s48.36,16.58,68.81-18.56,74.79-128,74.79-128Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M984.18,134.54s-22.46-3.51-41.4,21.08c0,0-5.47-21.08-28.91-21.08,0,0-20-2-39.9,22.59l2.4-19.08H847.55L826.1,242.44h33.42L871,190.25s6.47-26.61,23.93-26.1,11,27.61,9.48,33.62-9.48,44.16-9.48,44.16h33.92l11.46-49.18s7-29.1,24.93-28.1,10,30.11,7.48,40.15l-8,37.13h33.9l13-67.76S1020.08,134.54,984.18,134.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiyarams01);
export default __webpack_public_path__ + "static/media/siyarams-01.efe02b3944d067b4fbb045c9e1543f29.svg";
export { ForwardRef as ReactComponent };